import Vue from 'vue'
import Router from 'vue-router'
import home from '@/page/home'
import introduction from '@/page/introduction'
import fingerpost from '@/page/fingerpost'
import navigation from '@/page/navigation'
import application from '@/page/application'
import list from '@/page/list'
import fingerpostI from "@/page/fingerpostI";
import inquire from "@/page/inquire";
import inquire2 from "@/page/inquire2";
import JudgmentCase from "@/page/JudgmentCase"
import law from "@/page/law"
import CaseInquiry from "@/page/CaseInquiry"


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/introduction',
      name: 'introduction',
      component: introduction
    },
    {
      path: '/fingerpost',
      name: 'fingerpost',
      component: fingerpost,
      // children: [{
      //   path: '/fingerpostI',
      //   name:"fingerpostI",
      //   component: fingerpostI,
      // }]
    },
    // 调解指南
    {
      path: '/fingerpostI',
      name: "fingerpostI",
      component: fingerpostI,
    },
    {
      path: '/navigation',
      name: 'navigation',
      component: navigation
    },
    {
      path: '/application',
      name: 'application',
      component: application
    },
    {
      path: '/list',
      name: 'list',
      component: list
    },
    {
      path: "/inquire",
      name: "inquire",
      component: inquire
    },
    {
      path: "/inquire2",
      name: "inquire2",
      component: inquire2
    },
    {
      path: "/JudgmentCase",
      name: "JudgmentCase",
      component: JudgmentCase
    }
    ,
    {
      path: "/law",
      name: "law",
      component: law
    },{
      path:"/CaseInquiry",
      name:"CaseInquiry",
      component:CaseInquiry
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js